import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import bootbox from 'bootbox'
import { toast } from 'react-toastify'

import { appendModel, deleteSite, modifyModelAttr  } from '../../../../features/site/siteSlice'
import { addSite, updateSite, deleteSiteById, uploadLogo } from '../../../utils/Organizations'
import OrganizationUsers from '../UserTypes/OrganizationUsers'
import SidePanelToggle from '../../Layout/Common/SidePanelToggle'
import { debounce, getImageSpecs, MILITARY_DICTIONARY, toBase64 } from '../../../utils/common'
import { getUsers } from '../../../utils/Users'

const INITIAL_STATE = {
    userServicePanel: false,
    searchTerm: "",
    logo: null
}
function OrganizationModification(props){
    const dispatch = useDispatch()

    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)


    useEffect(() => {
        if(state.userServicePanel){
            getUsers(model.topOrgForm.siteId).then(({response, error}) => {
                if(response){
                    dispatch(appendModel({
                        users: response.users || []
                    }))
                } else {
                    dispatch(appendModel({
                        users: []
                    }))
                }
            })
        }
    }, [state.userServicePanel])

    const onDelete = async() => {
        bootbox.confirm({
            size: "small",
            title: `Corfirmation`,
            message: `Are you sure you want to delete ${model.topOrgForm.name}?`,
            buttons: {
                cancel: {
                    label: '<i class="fa fa-times"></i> No'
                },
                confirm: {
                    className: 'btn-danger',
                    label: '<i class="fa fa-check"></i> Yes'
                }
            },
            callback: async function (result) {
                if(result){

                    const {response, error } = await deleteSiteById(model?.topOrgForm?.siteId)
                    
                    if(response){
                        toast.success("Organization has been deleted")

                        await dispatch(deleteSite({
                            siteId: model?.topOrgForm?.siteId, 
                            siteType: "TOP_ORG"
                        }))

                        await props.onDeleteSite(model?.topOrgForm?.siteId, "ORG")
                    }
                }
            }
        });

    }

    const onChange = (property="attr", bool=false) => (e) => {
        let modelCopy = {topOrgForm: {...model.topOrgForm}}

        if(property){
            modelCopy.topOrgForm[property] = {
                ...modelCopy.topOrgForm[property],
                [e.target.name]: bool ? !modelCopy.topOrgForm[property][e.target.name] : e.target.value
            }
        } else {
            modelCopy.topOrgForm[e.target.name] = bool ? !modelCopy.topOrgForm[e.target.name] : e.target.value
        }

        dispatch(modifyModelAttr({
            key: "topOrgForm",
            body: modelCopy.topOrgForm
        }))
    }

    const saveSite = async() => {
        if(model.topOrgForm?.siteId) {
            let logoUrl = model.topOrgForm?.attr?.logo ?? null

            if(state.logo !== null){
                const respLogo = await uploadLogo(state.logo)
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}

                logoUrl = logoObj?.logoUrl ?? null
            }

            await updateSite(model.topOrgForm?.siteId, null, {
                site: {
                    ...model.topOrgForm,
                    attr: {
                        ...model.topOrgForm.attr,
                        logo: logoUrl
                    }
                }
            })
            
            let all = [...model.all]

            const allIdx = all.findIndex(a => a.siteId === model.topOrgForm.siteId)

            if(allIdx){
                all[allIdx] = {
                    ...model.topOrgForm,
                    attr: {
                        ...model.topOrgForm.attr,
                        logo: logoUrl
                    }
                }
            }

            let organizations = [...model.organizations]

            organizations[model.orgActiveIdx] = {
                ...model.topOrgForm,
                attr: {
                    ...model.topOrgForm.attr,
                    logo: logoUrl
                }
            }
            
            dispatch(appendModel({
                logo: logoUrl,
                organizations,
                all
            }))

            toast.success("Update successful")
        } else {
            let logoUrl = model.topOrgForm?.attr?.logo ?? null

            if(state.logo !== null){
                const respLogo = await uploadLogo(state.logo)
                let logoObj = respLogo?.response ? JSON.parse(new TextDecoder().decode(respLogo?.response)) : {}

                logoUrl = logoObj?.logoUrl ?? null
            }

            let sForm = {
                ...model.topOrgForm,
                attr: {
                    ...model.topOrgForm.attr,
                    token: model.reseller ? model.userSite.siteId : isAdmin ? (model?.topOrgForm?.attr?.token ?? undefined) : undefined,
                    logo: logoUrl
                },
                sitePath: "/"
            }
            
            const {response, error} = await addSite(null, {
                site: sForm
            })
            
            sForm.siteId = response.siteId
            if(response.sitePath){
                sForm.sitePath = response.sitePath
            } else {
                sForm.sitePath = '/ISL/'+sForm.siteId
            }

            dispatch(appendModel({
                logo: logoUrl,
                organizations: [...model.organizations, {...sForm}],
                organizationsFilter: [...model.organizationsFilter, {...sForm}],
                all: [...model.all, {...sForm}],
                topOrgForm: sForm
            }))
            
            toast.success("Organization has been created successfully")
        }

    }

    const selectMilitaryBranch = (key) => {
        let modelCopy = {topOrgForm: {...model.topOrgForm}}

        if(modelCopy.topOrgForm?.attr?.militaryBranch === key){
            const {militaryBranch, ...attr} = model.topOrgForm.attr

            modelCopy.topOrgForm = {
                ...modelCopy.topOrgForm,
                attr
            }
        } else {
            modelCopy.topOrgForm = {
                ...modelCopy.topOrgForm,
                attr: {
                    ...modelCopy.topOrgForm.attr,
                    militaryBranch: key
                }
            }
        }

        dispatch(modifyModelAttr({
            key: "topOrgForm",
            body: modelCopy.topOrgForm
        }))
    }


    const onLogoChange = async(e) => {        
        const file = e.target.files[0]
        
        setState(prevState => ({
            ...prevState,
            logo: file
        }))
    }

    const { topOrgForm } = model

    const inputDisabled = model.reseller && model.isAffiliate ? true : false

    return <>
        <div class="card card-raised h-100">
            <div class="card-body p-20">
                <div className="d-flex justify-content-between align-items-center">
                    <div class="overline text-muted mb-4">Organization</div>
                    <div className="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                        {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className="btn-group">
                            <button className="btn btn-lg btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {topOrgForm?.siteId && !model.orgFixed && <button className="btn btn-lg btn-outline-danger" id="orgDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                        </div>}
                        <div className="btn-group">
                            {topOrgForm?.siteId && <button className="btn btn-lg btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                    <div className="d-block d-sm-block d-md-block d-lg-none d-xl-none">
                        <div className="btn-group">
                            <button className="btn btn-outline-primary" onClick={() => props.onGoBack()}>
                                <i class="fas fa-chevron-circle-left"></i> Back
                            </button>
                            {!model.reseller || (model.reseller && !model.isAffiliate) && <><button className="btn btn-primary" onClick={() => saveSite()}>
                                <i class="fas fa-save"></i> Save
                            </button>
                            {topOrgForm?.siteId && !model.orgFixed && <button className="btn btn-outline-danger" id="orgDeleteBtn" onClick={() => onDelete()}>
                                <i class="fas fa-trash-alt"></i> Delete
                            </button>}
                            </>}
                        </div>
                        <div className="btn-group">
                            {topOrgForm?.siteId && <button className="btn btn-outline-info" onClick={e => setState(prev => ({...prev, userServicePanel: true}))}>
                                <i class="fas fa-user-alt"></i> Users
                            </button>}
                        </div>
                    </div>
                </div>
                <h1 className="d-none d-sm-none d-md-none d-lg-block d-xl-block">{topOrgForm?.name}</h1>
                <h2 className="d-block d-sm-block d-md-block d-lg-none d-xl-none">{topOrgForm?.name}</h2>
                <form class="form-horizontal">
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3" for="fullname">Organization Name:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="name" value={topOrgForm?.name} onChange={onChange(null)} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Address:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="address" value={topOrgForm?.attr?.address} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">City:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="city" value={topOrgForm?.attr?.city} onChange={onChange()} disabled={inputDisabled}  />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">State:</label>
                        <div class="col-sm-6">
                            <select class="form-control" name="state" value={topOrgForm?.attr?.state} onChange={onChange()} disabled={inputDisabled}>
                                <option value="AL">Alabama</option>
                                <option value="AK">Alaska</option>
                                <option value="AZ">Arizona</option>
                                <option value="AR">Arkansas</option>
                                <option value="CA">California</option>
                                <option value="CO">Colorado</option>
                                <option value="CT">Connecticut</option>
                                <option value="DE">Delaware</option>
                                <option value="FL">Florida</option>
                                <option value="GA">Georgia</option>
                                <option value="HI">Hawaii</option>
                                <option value="ID">Idaho</option>
                                <option value="IL">Illinois</option>
                                <option value="IN">Indiana</option>
                                <option value="IA">Iowa</option>
                                <option value="KS">Kansas</option>
                                <option value="KY">Kentucky</option>
                                <option value="LA">Louisiana</option>
                                <option value="ME">Maine</option>
                                <option value="MD">Maryland</option>
                                <option value="MA">Massachusetts</option>
                                <option value="MI">Michigan</option>
                                <option value="MN">Minnesota</option>
                                <option value="MS">Mississippi</option>
                                <option value="MO">Missouri</option>
                                <option value="MT">Montana</option>
                                <option value="NE">Nebraska</option>
                                <option value="NV">Nevada</option>
                                <option value="NH">New Hampshire</option>
                                <option value="NJ">New Jersey</option>
                                <option value="NM">New Mexico</option>
                                <option value="NY">Ney York</option>
                                <option value="NC">North Carolina</option>
                                <option value="ND">North Dekota</option>
                                <option value="OH">Ohio</option>
                                <option value="OK">Oklahoma</option>
                                <option value="OR">Oregon</option>
                                <option value="PA">Pennsylvania</option>
                                <option value="RI">Rhode Island</option>
                                <option value="SC">South Carolina</option>
                                <option value="SD">South Dekota</option>
                                <option value="TN">Tennessee</option>
                                <option value="TX">Texas</option>
                                <option value="UT">Utah</option>
                                <option value="VT">Vermont</option>
                                <option value="VA">Virginia</option>
                                <option value="WA">Washington</option>
                                <option value="WV">West Virginia</option>
                                <option value="WI">Wisconsin</option>
                                <option value="WY">Wyoming</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Zip:</label>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" name="zip" value={topOrgForm?.attr?.zip} onChange={onChange()} disabled={inputDisabled} />
                        </div>
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Logo:</label>
                        <div className={topOrgForm?.attr?.logo ? 'col-sm-3': 'col-sm-6'}>
                            <input type="file" class="form-control" onChange={onLogoChange} disabled={inputDisabled} />
                        </div>
                        {topOrgForm?.attr?.logo && <div class="col-sm-3">
                            <img src={topOrgForm?.attr?.logo} style={{width:"100%"}} />
                        </div>}
                    </div>
                    <div class="form-group row m-b-10">
                        <label class="col-form-label col-sm-3">Military Badge:</label>
                        <div class="col-sm-9">
                            {Object.keys(MILITARY_DICTIONARY).map(key => <img className={`img-thumbnail img-fluid ${topOrgForm.attr.militaryBranch === key ? "border border-2 border-success" : ""}`}
                                onClick={() => selectMilitaryBranch(key)}
                                src={MILITARY_DICTIONARY[key]} />)}
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SidePanelToggle autoCloseOnBlur overrideActiveState={state.userServicePanel} showIconOnActive onClick={() =>setState(prev => ({...prev, userServicePanel: false}))}>
            <OrganizationUsers title={"Organization"} />
        </SidePanelToggle>
    </>
}

export default OrganizationModification